import type { CommentDto, CreateCommentRequest } from '@ledokol/contracts'
import { api } from './client'

export async function fetchComments(taskId: string): Promise<CommentDto[]> {
  const r = await api.get<CommentDto[]>(`/tasks/${taskId}/comments`)
  return r.data
}

export async function createComment(taskId: string, body: CreateCommentRequest): Promise<CommentDto> {
  const r = await api.post<CommentDto>(`/tasks/${taskId}/comments`, body)
  return r.data
}
